import * as ACTION from './constants';
// ACTION CREATORS
export const updateWelcomeVideo = (item) => ({ type: ACTION.UPDATE_WELCOME_VIDEO, item });
export const getUpdatedWelcomeVideo = (item) => (dispatch) => {
    dispatch(updateWelcomeVideo(item));
}